<script lang="ts">
	//Helpers
	import { isXT1ComponentDevice } from 'src/helpers/xt1_helpers/template_helpers';
	import {
		sendRequest,
		isDefaultTemplateType,
	} from 'src/helpers/xt1_helpers/template_request_helpers';
	//Components
	import IrrigationControllerV2 from './Irrigation/IrrigationControllerV2.svelte';
	import ThermostatControllerV2 from './Thermostat/ThermostatControllerV2.svelte';
	import ValveControllerV2 from './Valve/ValveControllerV2.svelte';
	import LightControllerV2 from './Light/LightControllerV2.svelte';
	import SwitchControllerV2 from './Switch/SwitchControllerV2.svelte';
	import Co2SensorStatusesV2 from './CO2Sensor/CO2SensorStatusesV2.svelte';
	import NeoValveControllerV2 from './NeoValve/NeoValveControllerV2.svelte';
	import EvChargerControllerV2 from './EvCharger/EvChargerControllerV2.svelte';
	import TemplateControllerV2 from './Components/TemplateControllerV2.svelte';
	import DehumidifierControllerV2 from './Dehumidifier/DehumidifierControllerV2.svelte';
	import WindowCoverControllerV2 from './WindowCover/WindowCoverControllerV2.svelte';
	import XT1ComponentDevice from 'src/components/XT1/GenComponent/XT1ComponentDevice.svelte';
	//Types
	import type { Device } from 'src/types/Device';
	import type { VCInterfaceStatus } from 'src/types/VirtualComponents';
	import { DeviceDrawer } from '@shelly/device-templates';

	export let device: Device, statuses: VCInterfaceStatus[];

	$: templateType = statuses?.[0]?.templateType;
	$: defaultTemplateType = isDefaultTemplateType(statuses?.[0]?.serviceType);
</script>

{#if defaultTemplateType}
	<DeviceDrawer {device} {statuses} templateType={statuses[0]?.serviceType} {sendRequest} />
{:else if templateType === 'irrigation'}
	<IrrigationControllerV2 {device} {statuses} />
{:else if templateType === 'light'}
	<LightControllerV2 {device} {statuses} />
{:else if templateType === 'switch'}
	<SwitchControllerV2 {device} {statuses} />
{:else if templateType === 'thermostat'}
	<ThermostatControllerV2 {device} {statuses} />
{:else if templateType === 'valve'}
	<ValveControllerV2 {device} {statuses} />
{:else if templateType === 'cover'}
	<WindowCoverControllerV2 {device} {statuses} />
{:else if templateType === 'co2-sensor'}
	<Co2SensorStatusesV2 {device} {statuses} />
{:else if templateType === 'neo-valve'}
	<NeoValveControllerV2 {device} {statuses} />
{:else if templateType === 'ev-charger'}
	<EvChargerControllerV2 {device} {statuses} on:click />
{:else if templateType === 'dehumidifier'}
	<DehumidifierControllerV2 {device} {statuses} on:click />
{:else if isXT1ComponentDevice(device)}
	<XT1ComponentDevice {device} useV2Components />
{:else}
	<TemplateControllerV2 {device} {statuses} />
{/if}
